import { Link } from 'react-router-dom';
import { Megaphone, Ban, Phone, Database, ArrowRight } from 'lucide-react';
import PageHeader from '../components/PageHeader.jsx';
import DocumentsManager from '../components/DocumentsManager.jsx';

// 💰 SALES — the outbound / revenue side of the account. A hub that re-homes the
// existing campaigns, contact lists, Do-Not-Call, and call review under one
// section, with "Create a campaign" as the primary action. The deeper flows
// (campaign builder, DNC list, call review) keep their own routes — this page
// is the entry point + a Sales-scoped notes/docs area the AI uses on sales calls.

const CARDS = [
  {
    to: '/campaigns',
    icon: Megaphone,
    title: 'Campaigns',
    blurb: 'Create and run outbound campaigns — each with its own AI roster, pitch, and schedule.',
    cta: 'Create a campaign',
    primary: true
  },
  {
    to: '/lists',
    icon: Database,
    title: 'Contact lists',
    blurb: 'Reusable contact databases you can spin campaigns up from.'
  },
  {
    to: '/do-not-call',
    icon: Ban,
    title: 'Do-Not-Call',
    blurb: 'TCPA opt-out list. The dialer scrubs this before every campaign call.'
  },
  {
    to: '/calls',
    icon: Phone,
    title: 'Call review & reports',
    blurb: 'Listen to recordings, read transcripts, and review outcomes.'
  }
];

export default function Sales() {
  return (
    <div className="px-6 md:px-10 py-8 max-w-4xl">
      <PageHeader
        title="Sales"
        subtitle="Outbound campaigns, your call lists, opt-outs, and call review — all in one place"
        actions={
          <Link to="/campaigns" className="btn-primary">
            <Megaphone size={16} /> Create a campaign
          </Link>
        }
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
        {CARDS.map(({ to, icon: Icon, title, blurb, cta, primary }) => (
          <Link
            key={to}
            to={to}
            className={`card group block transition-colors ${primary ? 'border-alfred-gold/40 hover:border-alfred-gold/70' : 'hover:border-stone-700'}`}
          >
            <div className="flex items-center gap-2 mb-2">
              <Icon size={18} className="text-alfred-gold" />
              <h3 className="text-stone-100 font-medium">{title}</h3>
            </div>
            <p className="text-sm text-stone-400">{blurb}</p>
            <div className="mt-3 inline-flex items-center gap-1 text-sm text-alfred-gold opacity-80 group-hover:opacity-100">
              {cta || `Open ${title}`} <ArrowRight size={14} />
            </div>
          </Link>
        ))}
      </div>

      <DocumentsManager
        area="sales"
        title="Sales notes & documents"
        blurb="Add notes and upload documents the AI uses on sales calls — pitch sheets, objection handling, pricing one-pagers. Anything marked “used by AI” is injected as reference material on outbound calls."
      />
    </div>
  );
}
